import Http from "@/services/Http";

const context = {
  serverUrl: "",
  token: "",
};

function init(configView) {
  context.serverUrl = configView.serverUrl;
}

function setToken(token) {
  context.token = token; //'3422f64fa0f206caee5af107650c5f92588ed3f0'
}

function sendReq(method, entity, data) {
  const reqConfig = Http.createReqConfig(
    context.serverUrl,
    method,
    entity,
    context.token
  );
  return Http.send(reqConfig, data);
}

export default {
  init,
  setToken,
  sendReq,
};
